module.exports = __webpack_public_path__ + "static/media/ernesto.6b577104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/ernesto.png
// module id = 339
// module chunks = 0